import { Component, ElementRef, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService } from 'src/app/Services/enforcement.service';

@Component({
    selector: 'app-citationtemplate',
    templateUrl: './citationtemplate.component.html',
    styleUrls: ['./citationtemplate.component.scss'],
    standalone: false
})
export class CitationTemplateComponent extends ModelEditor {
  constructor(
    private injector: Injector, 
  ) {
    super("enforcement/citations/templates", injector);
  }

  public override DefaultModel() {
    return {};
  }

  public override AfterModelLoaded(): void {
    if (this.Model?.Lines) {
      this.Model.Lines.sort((a: any, b: any) => a.Index - b.Index);
      
      // Set default values for lines
      this.Model.Lines.forEach((line: any) => {
        if (line.LineType === undefined) {
          line.LineType = 'text';
        }
        
        if (line.LineType === 'barcode') {
          if (line.BarcodeType === undefined) {
            line.BarcodeType = 'Code128';
          }
          if (line.Orientation === undefined) {
            line.Orientation = 'Horizontal';
          }
          if (line.Width === undefined) {
            line.Width = 150;
          }
          if (line.Height === undefined) {
            line.Height = 50;
          }
        }
      });
    }
  }

  public override BeforeSave(): boolean | void {
    return true;
  }

  public override Validators() {
    return {};
  }
  
  public formatText(text: string): string {
    if (!text) return '';

    let formattedText = text;

    // Strip outer {if:...}{else}...{endif} and {if:...}{endif} wrappers,
    // keeping only the "then" branch text so condition syntax is never shown.
    const ifElseRegex = /\{if:[\s\S]*?\}([\s\S]*?)\{else\}([\s\S]*?)\{endif\}/gi;
    const simpleIfRegex = /\{if:[\s\S]*?\}([\s\S]*?)\{endif\}/gi;

    formattedText = formattedText.replace(ifElseRegex, '$1');
    formattedText = formattedText.replace(simpleIfRegex, '$1');

    // Apply formatting tags, supporting nested tags by looping until stable
    let previousText = '';
    while (previousText !== formattedText) {
      previousText = formattedText;
      formattedText = formattedText.replace(/\[\s*u\s*\]([\s\S]*?)\[\s*\/\s*u\s*\]/gi, '<u>$1</u>');
      formattedText = formattedText.replace(/\[\s*i\s*\]([\s\S]*?)\[\s*\/\s*i\s*\]/gi, '<em>$1</em>');
      formattedText = formattedText.replace(/\[\s*b\s*\]([\s\S]*?)\[\s*\/\s*b\s*\]/gi, '<strong>$1</strong>');
      formattedText = formattedText.replace(/\[\s*m\s*\]([\s\S]*?)\[\s*\/\s*m\s*\]/gi, '<span class="ct-medium">$1</span>');
      formattedText = formattedText.replace(/\[\s*l\s*\]([\s\S]*?)\[\s*\/\s*l\s*\]/gi, '<span class="ct-large">$1</span>');
      formattedText = formattedText.replace(/\[\s*uc\s*\]([\s\S]*?)\[\s*\/\s*uc\s*\]/gi, '<span class="ct-uc">$1</span>');
    }

    return formattedText;
  }
  
  public getBarcodeTypeName(barcodeType: string): string {
    switch(barcodeType) {
      case 'Code128': return 'Code 128';
      case 'QR': return 'QR Code';
      case 'Code39': return 'Code 39';
      case 'PDF417': return 'PDF 417';
      default: return barcodeType || 'Unknown';
    }
  }
} 
